import { starRating, buttonRating } from '../styles/legacy';
import { starRating as starRatingCitron, buttonRating as buttonRatingCitron } from '../styles/legacy';
import { citrusStyled } from '@citrus/runtime';
export var StarRating = citrusStyled.div('starRating', { legacy: starRating, citrus2022: starRatingCitron });
export var ButtonRating = citrusStyled.div('buttonRating', { legacy: buttonRating, citrus2022: buttonRatingCitron });
export var Styled = {
    StarRating: StarRating,
    ButtonRating: ButtonRating,
};
